<section class="details-shell" [attr.lang]="language()" aria-label="Product details">
  <a class="back-link" routerLink="/">{{ t('back') }}</a>

  @if (product(); as currentProduct) {
    <article class="details-card">
      <div class="details-layout">
        <section class="details-main">
          <header class="details-header">
            <h1>{{ productName(currentProduct) }}</h1>
          </header>

          <p class="details-description">{{ productDescription(currentProduct) }}</p>

          @if (currentProduct.categories && currentProduct.categories.length > 0) {
            <section class="meta-group">
              <h2>{{ t('categories') }}</h2>
              <div class="chips-wrap">
                @for (category of currentProduct.categories; track category.id) {
                  <span>{{ categoryName(category) }}</span>
                }
              </div>
            </section>
          }

          @if (currentProduct.product_video_link_1) {
            <section class="video-wrap">
              <h2>{{ t('productVideo') }}</h2>
              <video controls preload="none" [src]="currentProduct.product_video_link_1"></video>
            </section>
          }

          <div class="contact-pricing-wrap">
            <a class="contact-pricing-link" [href]="'tel:' + phoneHref">{{ t('contactPricing') }}</a>
          </div>
        </section>

        <aside class="details-media" aria-label="Product image slider">
          @if (imageURLs().length > 0) {
            <div class="media-stage">
              <img [src]="activeImageURL()" [alt]="productName(currentProduct)" loading="eager" decoding="async" />

              @if (hasMultipleImages()) {
                <button type="button" class="slide-nav prev" (click)="showPreviousImage()" aria-label="Previous image">&#8249;</button>
                <button type="button" class="slide-nav next" (click)="showNextImage()" aria-label="Next image">&#8250;</button>
              }
            </div>

            @if (hasMultipleImages()) {
              <div class="thumb-row" aria-label="Image thumbnails">
                @for (image of imageURLs(); track image; let imageIndex = $index) {
                  <button
                    type="button"
                    class="thumb-btn"
                    [class.active]="currentImageIndex() === imageIndex"
                    (click)="selectImage(imageIndex)"
                  >
                    <img [src]="image" [alt]="productName(currentProduct)" loading="lazy" decoding="async" />
                  </button>
                }
              </div>
            }
          } @else {
            <div class="media-placeholder">No image available.</div>
          }
        </aside>
      </div>
    </article>
  } @else if (loading()) {
    <p class="state-note">{{ t('loading') }}</p>
  } @else {
    <p class="state-note error-note">{{ t('notFound') }}</p>
  }
</section>
